import { max, mean, min, nest, sum, timeMonday, timeMonth, values } from "d3";
//1. For run http request

export const TotalCurrencyExposure = function(
  _origin,
  _origintype,
  _apiService,
  _spot,
  _d3 = null,
  _selectedDaysCandle,
  _intervalCandle,
  _initialM2M,
) {
  this._origin = _origin;
  this._origintype = _origintype;
  // this._params = _params
  this._apiService = _apiService;
  this._spot = _spot;
  this._d3 = _d3;
  this._selectedDaysCandle = _selectedDaysCandle;
  this._intervalCandle = _intervalCandle;
  this._initialM2M = _initialM2M;
};
TotalCurrencyExposure.prototype.initRequest = function(_context) {
  switch (this._origintype) {
    case "csv":
      return this.getDataCSV();
    case "api":
      return this.getDataAPI(_context);
    default:
      break;
  }
};
// =================== ForecastAnalisys =================== //
// Aplicando filtros a datos en csv
// parseForecastAnalisysDataRaw(data) {
//     var parseDate = d3.utcParse("%Y-%m-%d");
//     return data.map(d => ({
//         date: parseDate(d["Date"]),
//         high: d["High"],
//         low: d["Low"],
//         open: d["Open"],
//         close: d["Close"]
//     }))
// },
// Realizando la busqueda en el csv y llamando la funcion del los filtros

TotalCurrencyExposure.prototype.getDataCSV = function() {};

TotalCurrencyExposure.prototype.weekYear = function(date) {
  var dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return (
    Math.ceil(((date - yearStart) / 86400000 + 1) / 7) +
    date.getFullYear() * 100
  );
};

TotalCurrencyExposure.prototype.dataCompressCandle = function(
  data,
  intervalCandle,
  candleChartDataRaw,
) {
  // TODO: que pasa con los periodos en los que no hay datos y manda +-inf, null, nan, etc
  var req = this;
  // Slice data, and nest to render Candle and cumulative charts
  function timeCompareCandle(dat, intervalCandle) {
    let durfn;
    if (intervalCandle === "week") {
      durfn = timeMonday(dat);
    } else if (intervalCandle === "weekYear") {
      durfn = req.weekYear(dat);
    } else if (intervalCandle === "month") {
      durfn = timeMonth(dat);
    } else if (intervalCandle === "day") {
      durfn = dat;
    } else {
      durfn = dat;
    }
    return durfn;
  }
  let generatedData = nest()
    .key(function(d) {
      return timeCompareCandle(d.observation_date, intervalCandle);
    })
    .rollup(function(v) {
      let observation_date = timeCompareCandle(
        values(v).pop().observation_date,
        intervalCandle,
      );
      let open = values(v).shift().open;
      let low = min(v, function(d) {
        return d.low;
      });
      let high = max(v, function(d) {
        return d.high;
      });
      let close = values(v).pop().close;
      let hedge_value_hedge;
      let hedge_value_cumsum;
      try {
        hedge_value_hedge = sum(v, function(d) {
          return d.hedge_value_hedge;
        });
        hedge_value_cumsum = values(v).pop().hedge_value_cumsum;
      } catch (e) {
        hedge_value_hedge = 0;
        hedge_value_cumsum = 0;
        console.log(e);
      }

      return {
        observation_date: observation_date,
        open: open,
        low: low,
        high: high,
        close: close,
        hedge_value_hedge: hedge_value_hedge,
        hedge_value_cumsum: hedge_value_cumsum,
      };
    })
    .entries(data)
    .map(function(d) {
      return d.value;
    });
  try {
    this._initialM2M =
      candleChartDataRaw[
        candleChartDataRaw.length - this._selectedDaysCandle - 1
      ].hedge_value_cumsum;
  } catch (e) {
    this._initialM2M = 0;
    console.log(e);
  }
  // TODO: la linea anterior no devuelve ningun valor, asi q lo puse en currency.vue el calculo
  return generatedData;
};

TotalCurrencyExposure.prototype.transformCandleChartData = function(
  candleChartDataRaw,
  _intervalCandle,
  _selectedDaysCandle,
  _spot,
) {
  // TODO: que pasa con los periodos en los que no hay datos y manda +-inf, null, nan, etc
  // Include selected spot to compress data and render Candle and cumulative charts
  var data = [];
  if (candleChartDataRaw.length > 0) {
    data = candleChartDataRaw;
    if (_spot) {
      data[data.length - 1].close = _spot;
      data[data.length - 1].settle = _spot;
      data[data.length - 1].high = Math.max(_spot, data[data.length - 1].high);
      data[data.length - 1].low = Math.min(_spot, data[data.length - 1].low);
      data = this.dataCompressCandle(
        this.toSlice(data, _selectedDaysCandle),
        _intervalCandle,
        candleChartDataRaw,
      );
    }
  }
  return data;
};

TotalCurrencyExposure.prototype.toSlice = function(data, selectedDaysCandle) {
  return data.slice(-selectedDaysCandle);
};

// ================ Markets Data Transformations ================ ============== ===========
// TODO: estas dos sigiuentes son temporales para ver como solucionamos, son para los candles solitos
TotalCurrencyExposure.prototype.transformData = function(
  candleChartDataRaw,
  _intervalCandle,
  _selectedDaysCandle,
  _spot,
) {
  // TODO: que pasa con los periodos en los que no hay datos y manda +-inf, null, nan, etc
  // Include selected spot to compress data and render Candle and cumulative charts
  var data = [];
  if (candleChartDataRaw.length > 0) {
    data = candleChartDataRaw;
    if (_spot) {
      data[data.length - 1].close = _spot;
      data[data.length - 1].settle = _spot;
      data[data.length - 1].high = Math.max(_spot, data[data.length - 1].high);
      data[data.length - 1].low = Math.min(_spot, data[data.length - 1].low);
      data = this.dataCompress(
        this.toSlice(data, _selectedDaysCandle),
        _intervalCandle,
        candleChartDataRaw,
      );
    }
  }
  return data;
};

TotalCurrencyExposure.prototype.dataCompress = function(
  data,
  intervalCandle,
  addDate = false,
) {
  // TODO: que pasa con los periodos en los que no hay datos y manda +-inf, null, nan, etc
  var req = this;
  // Slice data, and nest to render Candle and cumulative charts
  function timeCompareCandle(dat, intervalCandle) {
    let durfn;
    if (intervalCandle === "week") {
      durfn = timeMonday(dat);
    } else if (intervalCandle === "weekYear") {
      durfn = req.weekYear(dat);
    } else if (intervalCandle === "month") {
      durfn = timeMonth(dat);
    } else if (intervalCandle === "day") {
      durfn = dat;
    } else {
      durfn = dat;
    }
    return durfn;
  }
  let generatedData = nest()
    .key(function(d) {
      return timeCompareCandle(d.date, intervalCandle);
    })
    .rollup(function(v) {
      let date = timeCompareCandle(values(v).pop().date, intervalCandle);
      let dat;
      if (addDate) {
        dat = timeCompareCandle(values(v).pop().date, "week");
      }
      let open = values(v).shift().open;
      let low = min(v, function(d) {
        return d.low;
      });
      let high = max(v, function(d) {
        return d.high;
      });
      let close = values(v).pop().close;
      let ave = mean(v, function(d) {
        return d.close;
      });
      return addDate
        ? {
            date: date,
            dat: dat,
            open: open,
            low: low,
            high: high,
            close: close,
            ave: ave,
          }
        : {
            date: date,
            open: open,
            low: low,
            high: high,
            close: close,
            ave: ave,
          };
    })
    .entries(data)
    .map(function(d) {
      return d.value;
    });
  return generatedData;
};

TotalCurrencyExposure.prototype.parseSeasonalData = function(data) {
  let first = data.map((d) => d.dat.getFullYear()).findIndex((d) => d === 2023);
  let firstDate = data[first].dat;
  firstDate = new Date(firstDate.setDate(firstDate.getDate() - 7));
  let columns = Array.from(Array(53).keys()).map((d) => d + 1);
  let columnDates = Array.from(Array(53).keys()).map(
    () => new Date(firstDate.setDate(firstDate.getDate() + 7)),
  );
  let initYear = new Date();
  let years = Array.from(Array(11).keys()).map((d) =>
    (d + initYear.getFullYear() - 10).toString(),
  );
  initYear = new Date();
  initYear = (initYear.getFullYear() - 10) * 100 + 1;

  function transformVals(vals) {
    let keys = Object.keys(vals);
    let valArray = Object.values(vals);
    let ave = valArray.reduce((a, b) => a + b) / valArray.length; // average
    let newVals = {};
    keys.forEach((d) => (newVals[d] = vals[d] / ave - 1));
    return newVals;
  }

  let values = [],
    vals = {},
    sw = 0,
    idx = 0,
    minimArr = [],
    minim = 0,
    maximArr = [],
    maxim = 0,
    arr = [];
  let dates = [],
    dats = {};
  for (let i = 0; i < data.length; i++) {
    idx = data[i].date - Math.floor(data[i].date / 100) * 100;
    if (sw === 1) {
      if (!(1 in vals) && idx === 2) {
        vals[1] = +data[i].ave;
        dats[1] = +1;
      }
      vals[idx] = +data[i].ave;
      dats[idx] = +idx;
    }
    if (i === data.length - 1) {
      vals = transformVals(vals);
      arr = Object.values(vals);
      minim = Math.min(...arr);
      maxim = Math.max(...arr);
      values.push(arr);
      dates.push(Object.values(dats));
      minimArr.push(minim);
      maximArr.push(maxim);
    } else if (data[i + 1].date >= initYear) {
      if (data[i].date < initYear) {
        if (sw === 1) {
          if (!(53 in vals)) {
            vals[53] = vals[52];
            dats[53] = dats[52];
          }
          vals = transformVals(vals);
          arr = Object.values(vals);
          minim = Math.min(...arr);
          maxim = Math.max(...arr);
          values.push(arr);
          dates.push(Object.values(dats));
          minimArr.push(minim);
          maximArr.push(maxim);
          vals = {};
          dats = {};
        }
        sw = 1;
        initYear += 100;
      }
    }
  }
  return {
    y: "Pre Weekly Seasonality",
    series: {
      names: years,
      values: values,
      dates: dates,
      min: minimArr,
      max: maximArr,
    },
    dates: columns,
    dts: columnDates,
  };
};

TotalCurrencyExposure.prototype.transformDataSeas = function(
  data,
  selectedYears,
) {
  let values = data.series.values.slice(-selectedYears);
  let names = data.series.names.slice(-selectedYears);
  let dates = data.series.dates.slice(-selectedYears);
  let minim = Math.min(...data.series.min.slice(-selectedYears));
  let maxim = Math.max(...data.series.max.slice(-selectedYears));
  let weekAve = {},
    ave = 0,
    iCount = 0;

  for (let i = 0; i < data.dates.length; i++) {
    ave = 0;
    iCount = 0;
    for (let j = 0; j < values.length; j++) {
      if (i in values[j]) {
        ave += values[j][i];
        iCount++;
      }
    }
    weekAve[data.dates[i]] = ave / iCount;
  }
  let years = [];
  names.forEach((d) => years.push(d));
  years.push("AVERAGE");
  let newValues = [];
  values.forEach((d) => newValues.push(d));
  newValues.push(Object.values(weekAve));
  let dateIdx = [];
  dates.forEach((d) => dateIdx.push(d));
  dateIdx.push(Object.values(data.dates));
  return {
    y: "WEEKLY SEASONALITY",
    series: {
      names: years,
      values: newValues,
      dates: dateIdx,
      min: minim,
      max: maxim,
    },
    dates: data.dates,
    dts: data.dts,
  };
};

TotalCurrencyExposure.prototype.marketsMinMaxYAxis = function(candleChartData) {
  // Calculate the y axis for Candle and Rates (topography) charts, depending on the data shown.
  var result = [0, 1000000000000000];
  if (candleChartData.length > 0) {
    result[0] = min(candleChartData, function(d) {
      return d.low;
    });
    result[1] = max(candleChartData, function(d) {
      return d.high;
    });
  }
  // var delta = (result[1] - result[0]) * 0.025;
  // result[0] -= delta;
  // result[1] += delta;
  return result;
};

// ================ Data Transformations ================ ============== ===========

TotalCurrencyExposure.prototype.minMaxCalc = function(result, data, showHide) {
  if (data.length > 0) {
    if (showHide) {
      result[0] = Math.min(
        result[0],
        min(data, function(d) {
          return Number.isFinite(d.strike) ? d.strike : Infinity;
        }),
      );
      result[1] = Math.max(
        result[1],
        max(data, function(d) {
          return Number.isFinite(d.strike) ? d.strike : 0;
        }),
      );
    }
  }
  return result;
};
// TODO: Dividir función, candlechart y planningchart
TotalCurrencyExposure.prototype.calculateMinMaxYAxis = function(
  candleChartData,
  planningChartData,
  showHideExposure,
  showHideHedges,
  showHideNet,
  longFwdData,
  showHideLongFwd,
  shortFwdData,
  showHideShortFwd,
  longCallData,
  showHideLongCall,
  shortCallData,
  showHideShortCall,
  longPutData,
  showHideLongPut,
  shortPutData,
  showHideShortPut,
) {
  // Calculate the y axis for Candle and Rates (topography) charts, depending on the data shown.
  var result = [0, 1000000000000000];
  if (candleChartData.length > 0) {
    result[0] = min(candleChartData, function(d) {
      return d.low;
    });
    result[1] = max(candleChartData, function(d) {
      return d.high;
    });
  }
  if (planningChartData.length > 0) {
    if (showHideExposure) {
      result[0] = Math.min(
        result[0],
        min(planningChartData, function(d) {
          return Number.isFinite(d.m2m_rate) ? d.m2m_rate : Infinity;
        }),
      );
      result[1] = Math.max(
        result[1],
        max(planningChartData, function(d) {
          return Number.isFinite(d.m2m_rate) ? d.m2m_rate : 0;
        }),
      );
    }
    if (showHideHedges) {
      result[0] = Math.min(
        result[0],
        min(planningChartData, function(d) {
          return Number.isFinite(d.hedge_rate) ? d.hedge_rate : Infinity;
        }),
      );
      result[1] = Math.max(
        result[1],
        max(planningChartData, function(d) {
          return Number.isFinite(d.hedge_rate) ? d.hedge_rate : 0;
        }),
      );
    }
    if (showHideNet) {
      result[0] = Math.min(
        result[0],
        min(planningChartData, function(d) {
          return Number.isFinite(d.net_rate) ? d.net_rate : Infinity;
        }),
      );
      result[1] = Math.max(
        result[1],
        max(planningChartData, function(d) {
          return Number.isFinite(d.net_rate) ? d.net_rate : 0;
        }),
      );
    }
  }
  result = this.minMaxCalc(result, longFwdData, showHideLongFwd);
  result = this.minMaxCalc(result, shortFwdData, showHideShortFwd);
  result = this.minMaxCalc(result, longCallData, showHideLongCall);
  result = this.minMaxCalc(result, shortCallData, showHideShortCall);
  result = this.minMaxCalc(result, longPutData, showHideLongPut);
  result = this.minMaxCalc(result, shortPutData, showHideShortPut);
  var delta = (result[1] - result[0]) * 0.025;
  result[0] -= delta;
  result[1] += delta;
  return result;
};

// revisar cuales son de contexto
TotalCurrencyExposure.prototype.setintervalCandle = function(_context) {
  // When user changes 1M, 2M, etc intervals for Candle and Cumulative charts,
  // define date formats, calculate data and render charts
  _context.intervalCandle =
    _context.tIntervalsCandle[_context.pickedDateCandle];
  _context.selectedDaysCandle = _context.tDaysCandle[_context.pickedDateCandle];
  _context.dateFormatCandle = _context.tFormatCandle[_context.intervalCandle];
  _context.datePrefixCandle =
    _context.prefixOptionsCandle[_context.intervalCandle];
  _context.initialM2M =
    _context.candleChartDataRaw[
      _context.candleChartDataRaw.length - _context.selectedDaysCandle - 1
    ].hedge_value_cumsum;
  _context.candleChartData = this.transformCandleChartData(
    _context.candleChartDataRaw,
    _context.intervalCandle,
    _context.selectedDaysCandle,
    _context.spot,
  ); // add spot and compress
  let auxMinMax = JSON.parse(JSON.stringify(_context.minMaxYAxis));
  _context.minMaxYAxis = this.calculateMinMaxYAxis(
    _context.candleChartData,
    _context.planningChartData,
    _context.showHideExposure,
    _context.showHideHedges,
    _context.showHideNet,
    _context.longFwdData,
    _context.showHideLongFwd,
    _context.shortFwdData,
    _context.showHideShortFwd,
    _context.longCallData,
    _context.showHideLongCall,
    _context.shortCallData,
    _context.showHideShortCall,
    _context.longPutData,
    _context.showHideLongPut,
    _context.shortPutData,
    _context.showHideShortPut,
  );
  _context.renderCandle = 1 + _context.renderCandle;
  if (
    auxMinMax[0] != _context.minMaxYAxis[0] ||
    auxMinMax[1] != _context.minMaxYAxis[1]
  ) {
    _context.renderTopography = 1 + _context.renderTopography;
  }
};
